import { Link } from "react-router-dom";
import { CheckCircle2, XCircle, ArrowLeft } from "lucide-react";

export function CheckoutComplete() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-6 text-center">
      <div className="max-w-md">
        <CheckCircle2 size={64} className="text-[var(--accent)] mx-auto mb-6 drop-shadow-[0_0_18px_rgba(218,255,0,0.7)]" />
        <div className="bracket mb-2">// TRANSACTION_COMPLETE</div>
        <h1 className="font-display text-4xl md:text-5xl font-extrabold uppercase tracking-tight text-glow mb-4">
          PAYMENT RECEIVED
        </h1>
        <p className="font-mono text-xs text-[var(--muted)] uppercase tracking-widest mb-8 leading-relaxed">
          // your order is being processed by tebex.<br />
          // assets will be delivered to your cfx account shortly.
        </p>
        <Link to="/" className="btn-mega inline-flex items-center gap-2 !py-3 !px-6 !text-xs" data-testid="back-to-store">
          <ArrowLeft size={12} /> BACK TO STORE
        </Link>
      </div>
    </div>
  );
}

export function CheckoutCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-black px-6 text-center">
      <div className="max-w-md">
        <XCircle size={64} className="text-red-500 mx-auto mb-6" />
        <div className="bracket mb-2">// TRANSACTION_ABORTED</div>
        <h1 className="font-display text-4xl md:text-5xl font-extrabold uppercase tracking-tight mb-4">
          PAYMENT CANCELLED
        </h1>
        <p className="font-mono text-xs text-[var(--muted)] uppercase tracking-widest mb-8">
          // no charge applied to your account.
        </p>
        <Link to="/" className="btn-mega inline-flex items-center gap-2 !py-3 !px-6 !text-xs">
          <ArrowLeft size={12} /> BACK TO STORE
        </Link>
      </div>
    </div>
  );
}
